import React, { useEffect, useRef, useState } from "react";
import styles from "./AboutHeroSection.module.css";
import { useNavigate } from "react-router-dom";

const AboutHeroSection = () => {
  // Section 1 State & Ref
  const section1Ref = useRef(null);
  const [visible1, setVisible1] = useState(false);

  // Section 2 State & Ref
  const section2Ref = useRef(null);
  const [visible2, setVisible2] = useState(false);

  useEffect(() => {
    const observerOptions = { threshold: 0.25 };

    const observer1 = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible1(true);
    }, observerOptions);

    const observer2 = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible2(true);
    }, observerOptions);

    if (section1Ref.current) observer1.observe(section1Ref.current);
    if (section2Ref.current) observer2.observe(section2Ref.current);

    return () => {
      observer1.disconnect();
      observer2.disconnect();
    };
  }, []);

  const navigate = useNavigate()

  const navigateToMenu = () =>{
    navigate('/menu')
  }
  return (
    <>
      {/* SECTION 1: HERO & ABOUT TEXT */}
      <section 
        ref={section1Ref} 
        className={`${styles.wrapper} ${visible1 ? styles.show : ""}`}
      >
        <div className={styles.hero}>
          <img src={'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/DSC03098%201.png'} alt="Steak on board" />
        </div>

        <div className={styles.creamSection}>
          <div className={styles.container}>
            <h2 className={styles.sectionTitle}>About us</h2>
            <p className={styles.mainDescription}>
              Baglami brings together food, music, and people in a way that feels natural and unforced. Rooted in seasonal ingredients and shaped by global influences, the experience balances flavour with feeling. What begins at the table often becomes something more, as the space shifts from relaxed dining to a vibrant, social atmosphere. It’s about what’s served, how it’s shared, and the moments you return for.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 2: OVERLAPPING GRID */}
      <section 
        ref={section2Ref} 
        className={`${styles.blackSection} ${visible2 ? styles.show : ""}`}
      >
        <div className={styles.grid}>
          {/* Left Card */}
          <div className={styles.leftCard}>
            <div className={styles.imageWrapper}>
              <img src={'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/food-gallery/5-_DSC3486.jpg.jpeg'} alt="Chef cooking" />
            </div>
            <div className={styles.cardContent}>
              <h3>We connect farmers, producers, and cooks.</h3>
              <p>
               It begins with farmers, producers, and our kitchen coming together with purpose. Each step shapes food that’s fresh, well-crafted, and served with intention. From sourcing to preparation, every stage is handled with care, ensuring what reaches your table feels balanced, thoughtful, and consistently satisfying for every guest who visits.

              </p>
            </div>
          </div>

          {/* Right Card */}
          <div className={styles.rightCard} style={{ transitionDelay: "200ms" }}>
            <div className={styles.imageWrapper}>
              <img src={'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/image11.png'} alt="Slicing steak" />
            </div>
            <div className={styles.cardContent}>
              <h3>See all the way into our kitchen</h3>
              <p>
                Our kitchen is established on transparency and authenticity. From the ingredients we handpick to the way each dish is meticulously-crafted, everything is done in the open with precision, intention, and a genuine passion to serve. It’s a space where fragrances fill the room, processes unfold naturally, and every detail reflects the dedication behind it. What reaches your table carries both craft and a sense of authenticity.

              </p>
              <a href="/menu" className={styles.menuLink} onClick={navigateToMenu}>
                View Our Menu <span className={styles.arrow}>↘</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutHeroSection;